// common
export const PUT_REQUEST = 'consultationFee/PUT_REQUEST'
export const PUT_SUCCESS = 'consultationFee/PUT_SUCCESS'
export const PUT_FAILURE = 'consultationFee/PUT_FAILURE'